import styled from 'styled-components';
import { breakpoints } from 'assets/breakpoints';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import Slider from '@mui/material/Slider';

import Box from '@mui/material/Box';


export const Wrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  flex-direction: column;
  flex-wrap: wrap;
  margin: 25px 0;
  
  @media (min-width: ${breakpoints.desktop}) {
  justify-content: space-between;
  flex-direction: row;
  flex-wrap: wrap;
  padding: 0 25px;
  }
`;

export const Container = styled(Box)`
  width: calc(100% - 50px);
  align-self: center;
  align-items: center;
  margin: 10px 0px;
  background-color: rgba(255, 255, 255, 0.1);
  padding: 20px 25px;
  
  
  @media (min-width: ${breakpoints.desktop}) {
  width: calc(50% - 80px);
  margin: 15px 10px;
  
  .MuiSlider-thumbColorSecondary {
    &:hover {

    }
  }
  
  .css-1diafny-MuiSlider-root {
    padding: 20px 0;
  }
  }
`
export const Title = styled.h2`
  color: white;
  margin: 0;
`;

export const SelectedLabel = styled.h3`
  color: white;
  font-weight: normal;
  margin:0;
  font-size: 12px;
`;

export const StyledSlider = styled(Slider)`
  @media (max-width: ${breakpoints.desktop}) {
    pointer-events: none !important;
    .MuiSlider-thumb {
      z-index: 6;
      pointer-events: all !important;
    }
  }
`;
